var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.84961 9.65615C8.99492 9.80147 9.23398 9.80147 9.3793 9.65615C9.52461 9.51084 9.52461 9.27178 9.3793 9.12646L6.27383 6.021L9.3793 2.91553C9.52461 2.77021 9.52461 2.53115 9.3793 2.38584C9.23398 2.24053 8.99492 2.24053 8.84961 2.38584L5.74414 5.49131L2.63867 2.38584C2.49336 2.24053 2.2543 2.24053 2.10898 2.38584C1.96367 2.53115 1.96367 2.77021 2.10898 2.91553L5.21445 6.021L2.10898 9.12646C1.96367 9.27178 1.96367 9.51084 2.10898 9.65615C2.2543 9.80147 2.49336 9.80147 2.63867 9.65615L5.74414 6.55068L8.84961 9.65615Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fb032a39b5a9d0b3cf3aacfd587d4597.svg";
export { ForwardRef as ReactComponent };